"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
  query getImageHealthService($salesModelId: Int, $cacheVersion: String) {
    imageHealthV2(salesModelId: $salesModelId, cacheVersion: $cacheVersion) {
      modelHealth {
        modelNumber
        isHealthy
        healthCheckDate
        cacheVersion
        expectedImageCount
        actualImageCount
      }
    }
  }
`;exports.getImageHealth=e;
//# sourceMappingURL=queries.js.map
